module.exports = __webpack_public_path__ + "bg 1.png?482c9b542471143394acab2a09553b34";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg 1.png
// module id = 320
// module chunks = 0